<div class="tab-pane" style="height:300px;">
  <h3>{{cardTitle}}</h3>
  <p>No data available.</p>
</div>